












































import { Component, Prop, Vue } from "vue-property-decorator";
import { IOrder } from "@/models/orders";

@Component({
  components: {
    "order-provider": () =>
      import("@/components/app/global/orders/orderProvider.vue"),
    "order-summary": () =>
      import("@/components/app/global/orders/orderSummary.vue")
  }
})
export default class OrderModal extends Vue {
  // Props

  @Prop({ required: true })
  public orderId!: IOrder["id"];

  @Prop({ default: true })
  public showClientDetails!: boolean;

  // Methods

  public canGoToOrder(order?: IOrder) {
    if (!order?.client) return false;
    return !this.$_.isEmpty(order);
  }

  public onNotFound() {
    this.$emit("close");
  }
}
